import PropTypes from "prop-types";
import React from "react";
import Tooltipable from "~/components/effects/tooltipable";
import { EDITOR_TYPES } from "~/constants/EditorTypes";

const PRODUCT_COLORS = {
  recruiting: "green",
  retention: "blue",
};

const PRODUCT_LABELS = {
  recruiting: "Recruiting",
  retention: "Retention",
};

const ContextBadge = ({ product, editorType }) => {
  if (!editorType) {
    return null;
  }

  const editorConfig = EDITOR_TYPES[editorType];
  const editorLabel = editorConfig?.label || editorType;
  const color = PRODUCT_COLORS[product] || "gray";

  const productLabel = PRODUCT_LABELS[product] || null;

  const badgeText = productLabel
    ? `${productLabel} \u00B7 ${editorLabel}`
    : editorLabel;

  const tooltipText = `AI is generating content for ${productLabel || "this"} ${editorLabel}. Formatting and tone are automatically adjusted.`;

  return (
    <Tooltipable text={tooltipText} placement="bottom">
      <span
        className={`badge badge-pill badge-outline-${color} ml-2`}
        style={{ cursor: "help" }}
      >
        {badgeText}
      </span>
    </Tooltipable>
  );
};

ContextBadge.propTypes = {
  product: PropTypes.string,
  editorType: PropTypes.string,
};

export default ContextBadge;
